import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import Tooltip from 'apollo-react/components/Tooltip';
import DeleteIcon from 'apollo-react-icons/Trash';
import React, { memo } from 'react';

import { useTranslation } from '../../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  actionCell: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '8px !important',
  },
});

const ActionCell = memo(({ row }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const { deleteRow, Id } = row;

  return (
    <div className={classes.actionCell}>
      <Tooltip title={translateString('Delete')} disableFocusListener>
        <IconButton
          size="small"
          onClick={() => deleteRow(Id)}
          aria-label={translateString('Delete')}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
});

export default ActionCell;
